import type { FaireProductEntity } from "../../entity_types/product";

export const p_ptvks7p8uq: FaireProductEntity = {
  token: "p_ptvks7p8uq",
  type: "product",
  name: "Gold Filled Hamsa Hand Charm Pendant CZ Micro Pave, CP1186",
  brandToken: "b_7ef699gcdg",
  brandName: "Beads Creation",
  imageUrl:
    "https://cdn.faire.com/fastly/5c3d1e7f09fbc254d5cd31a84053a6f31685b18c3654387fc03a3c1fae562cc8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da42d4d9d6bfb402430cfcff0c83f048a08ee6a6380f927405e3dd3ed00305a4.jpeg",
    "https://cdn.faire.com/fastly/dfe54c23ed02af22f208b5230483a3fbe28f5a775f5b69a219d99609f199faa3.jpeg",
    "https://cdn.faire.com/fastly/70f55a8264ef64f148e615a7c3bd3c5f37ff1f694be4432d4f89e2b6ff4b6a32.jpeg",
    "https://cdn.faire.com/fastly/cfc3276871f6b5eaa6adfcc7ad183782a61aad5c51f5618ba5c485b43dab0d1e.jpeg",
  ],
  priceDollars: 4.27,
  description:
    "Creating your handcrafted jewelry pieces starts here! This is the best place to shop for fashionable and stylish jewelry findings with premium quality and competitive price!\nTake a look at more detail information about this item:\n\nDescription: \nMaterial: Brass Based with 18K Gold Filled\nSize: 9mm\nQTY: 1PC\n\n★Ship from CA, USA★\n\nAll sizes are approximate \nLead Free & Cadmium Free & Nickel Free\n\nIf you any questions regarding our products, bulk discount, and issue please send us a message\nThank you for your visit!\n\nCARE INSTRUCTIONS\n\nTo care for your delicate jewelry and maintain its quality and longevity, please follow these guidelines:\n\n- Avoid contact with chemical solutions, perfumes, sweat, and saltwater/chlorine.\n- Use a soft, damp cloth to wipe off your jewelry regularly.\n- Keep your jewelry dry to prevent tarnishing.\n- Store different types of jewelry separately in a sealed bag to prevent oxidization.",
  tags: [],
  msrpDollars: 8.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:29.877Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
